import { ChangeDetectionStrategy, Component, ElementRef, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { MatIconModule } from '@angular/material/icon';
import { filter, fromEvent } from 'rxjs';

@Component({
  selector: 'coin-v2-button',
  imports: [MatIconModule],
  templateUrl: './v2-button.component.html',
  styleUrls: ['./v2-button.component.scss'],
  host: {
    '[class]': 'type()', // currently using this class name for legacy support, in the future use `type-${type()}`
    '[class.disabled]': 'disabled()'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2ButtonComponent {
  readonly text = input<string>();
  readonly disabled = input(false);
  readonly icon = input<string>();
  readonly svgIcon = input<string>();
  readonly iconPos = input<ButtonIconPosition>('left');
  readonly type = input.required<ButtonType>();

  constructor() {
    this.blockClicksWhileDisabled();
  }

  private blockClicksWhileDisabled(): void {
    const element: HTMLElement = inject(ElementRef).nativeElement;
    fromEvent(element, 'click', { capture: true })
      .pipe(
        filter(() => this.disabled()),
        takeUntilDestroyed()
      )
      .subscribe(event => {
        event.preventDefault();
        event.stopImmediatePropagation();
      });
  }
}

export const BUTTON_TYPES = ['primary', 'secondary', 'white', 'outline', 'red', 'green', 'special'] as const;
export type ButtonType = (typeof BUTTON_TYPES)[number];

export const BUTTON_ICON_POSITIONS = ['left', 'right', 'above'] as const;
export type ButtonIconPosition = (typeof BUTTON_ICON_POSITIONS)[number];
